import { contractAddresses } from "web3/addresses"

import { useBBToken } from "./use-bb-token"

export function useOILToken() {
  const props = useBBToken(contractAddresses.OIL)
  return { ...props }
}
